//Angular
import { Component, OnInit, ViewContainerRef, Input, ComponentFactory, ReflectiveInjector, Compiler, Inject } from "@angular/core";

//Services
import { LanguageService } from "./../../../../services/cms/language.service";
import { ArticleService } from "./../../../../services/cms/article.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { TemplateService } from "./../../../../services/settings/template.service";



@Component({
    selector: "dy-article-list",
    template: ""
})

export class NewsListComponent implements OnInit 
{
    constructor
    (
        private _compiler: Compiler,
        private componentHelper: ComponentHelperService,
        private _elementRef: ViewContainerRef,
        private templateService: TemplateService,
        private articleService: ArticleService,
        @Inject('isBrowser') private isBrowser: boolean
    ) {}

    @Input() items: any;
    @Input() category: string;
    @Input() newsOrientation: string;
    @Input() headerTypeNews: string;
    @Input() columns: number = 4;
    
    ngOnInit() 
    {
        if (!this.isBrowser)
            return;

        //Depending on the type of the list, a different template is used
        let subComponentTemplateUrl: string;

        switch (this.newsOrientation) 
        {
            case "newsVertical": subComponentTemplateUrl = "newsListVerticalPageTemplate"; break;
            case "newsHorizontal": subComponentTemplateUrl = "newsListHorizontalPageTemplate"; break;
            case "newsVerticalBanner": subComponentTemplateUrl = "newsListVerticalBannerPageTemplate"; break;
            case "newsHorizontalBanner": subComponentTemplateUrl = "newsListHorizontalBannerHomepageTemplate"; break; 
        }

        this.articleService.getArticleList(this.category, subComponentTemplateUrl).subscribe(result => 
        {     
            let templateData = result;
            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(templateData, this.items, this.category, this.newsOrientation, this.headerTypeNews, this.columns);
            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }); 
    }

    private createSubComponent(response: any, inputItems: any, inputCategory: string, inputNewsOrientation: string, inputHeaderTypeNews: string, inputColumns: number) {

        @Component({
            template: response.TemplateHtml
        })

        class ChildComponent implements OnInit 
        {
            constructor
            (
                private languageService: LanguageService,
                private articleService: ArticleService
            ) {}

            items: any = inputItems;
            category: string = inputCategory;
            newsOrientation: string = inputNewsOrientation;
            headerTypeNews: string = inputHeaderTypeNews;
            lang: string = this.languageService.getLongLang();
            columns: number = inputColumns;

            ngOnInit() 
            {
                this.items = response.ArticleList;
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/cms/article/widget/news-list.component.ts